import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
import { mapboxToken } from "../helpers/mapbox_token"

export default class extends Controller {
  static targets = ["container"]
  static values = { geojson: Object }

  connect() {
    this.initializeMap();
  }

  disconnect() {
    if (this.map) {
      this.map.remove();
    }
  }

  initializeMap() {
    this.map = L.map(this.containerTarget, {
      zoomControl: true
    });

    // Add Mapbox tile layer
    L.tileLayer(`https://api.mapbox.com/styles/v1/allroadstaken/clzbxv6l3002l01p66v9eb66s/tiles/256/{z}/{x}/{y}@2x?access_token=${mapboxToken()}`, {
      maxZoom: 19,
      minZoom: 1,
      attribution: '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    // Add GeoJSON layer
    if (this.geojsonValue) {
      const geoJsonLayer = L.geoJSON(this.geojsonValue, {
        style: (feature) => {
          return {
            color: '#3388ff',
            weight: 3,
            opacity: 0.8,
            fillColor: '#3388ff',
            fillOpacity: 0.2
          };
        },
        pointToLayer: (feature, latlng) => {
          return L.circleMarker(latlng, {
            radius: 8,
            color: '#3388ff',
            weight: 2,
            opacity: 0.8,
            fillColor: '#3388ff',
            fillOpacity: 0.5
          });
        },
        onEachFeature: (feature, layer) => {
          if (feature.properties) {
            const props = Object.entries(feature.properties)
              .map(([key, value]) => `<strong>${key}:</strong> ${value}`)
              .join('<br>');
            if (props) {
              layer.bindPopup(props);
            }
          }
        }
      }).addTo(this.map);

      // Fit map to geometry bounds
      this.map.fitBounds(geoJsonLayer.getBounds(), {
        padding: [50, 50]
      });
    }
  }
}
